import { render, staticRenderFns } from "./fullscreen-off.vue?vue&type=template&id=78022ef4&"
import script from "./fullscreen-off.vue?vue&type=script&lang=js&"
export * from "./fullscreen-off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports